import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as fromCasesReducer from './+state/cases.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CasesEffects } from './+state/cases.effects';
import { AdjustmentsEffects } from './+state/adjustments/adjustments.effects';
import { CasesFacade } from './+state/cases.facade';
import { AdjustmentsFacade } from './+state/adjustments/adjustments.facade';
import { LocaleModule } from '@vpfa/locale';

@NgModule({
  imports: [
    CommonModule,
    LocaleModule,
    StoreModule.forFeature(fromCasesReducer.CASES_FEATURE_KEY, fromCasesReducer.reducer),
    EffectsModule.forFeature([CasesEffects, AdjustmentsEffects]),
  ],
  providers: [CasesFacade, AdjustmentsFacade],
})
export class CaseDataModule {}
